import React from 'react';
import { format } from 'date-fns';
import { Paper, Stack, Typography } from '@mui/material';
import EventBusyRoundedIcon from '@mui/icons-material/EventBusyRounded';

import {
  formatSubscriptionExpiryWarningMessage,
  type SubscriptionExpiryWarning,
} from '@/lib/subscriptionGate';
import { CS_PRIMARY } from './dashboardHomeTokens';

export interface DashboardSubscriptionExpiryBannerProps {
  warning: SubscriptionExpiryWarning;
}

export const DashboardSubscriptionExpiryBanner: React.FC<DashboardSubscriptionExpiryBannerProps> = ({
  warning,
}) => {
  const endDateLabel = format(new Date(warning.endsAt), 'd MMM yyyy');

  return (
    <Paper
      elevation={0}
      sx={{
        border: '1px solid #f5d08a',
        borderRadius: '12px',
        bgcolor: '#fffbeb',
        px: { xs: 2, sm: 2.5 },
        py: 1.5,
      }}
    >
      <Stack direction="row" spacing={1.25} alignItems="flex-start" sx={{ minWidth: 0 }}>
        <EventBusyRoundedIcon sx={{ color: '#b45309', fontSize: 22, mt: 0.15, flexShrink: 0 }} />
        <Stack spacing={0.35} sx={{ minWidth: 0 }}>
          <Typography sx={{ fontSize: 14, fontWeight: 700, color: '#92400e', lineHeight: 1.35 }}>
            {formatSubscriptionExpiryWarningMessage(warning)}
          </Typography>
          <Typography sx={{ fontSize: 13, color: '#a16207', lineHeight: 1.45 }}>
            Renew before {endDateLabel} to keep access to your clients, meal plans, and appointments.
            Need help? Contact{' '}
            <Typography
              component="a"
              href={`mailto:${warning.supportEmail}`}
              sx={{ fontSize: 13, color: CS_PRIMARY, textDecoration: 'underline' }}
            >
              {warning.supportEmail}
            </Typography>
            .
          </Typography>
        </Stack>
      </Stack>
    </Paper>
  );
};
